<template>
  <div id="buyerSaveProductsPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-bookmark fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">محصولات ذخیره شده</span>
                </div>
              </div>
            </div>
            <div v-if="isDataLoaded" class="row">
              <div class="col pt-0 ">
                <v-text-field
                    v-model="searchKeyWordProduct"
                    append-icon="far fa-magnifying-glass"
                    class="rounded-lg"
                    clearable
                    dense
                    flat
                    hide-details
                    placeholder="...Search Product"
                    solo
                    @keydown="searchProduct"
                    @click:clear="removeSearchHistory">
                </v-text-field>
              </div>
              <div v-if="!hasFavoriteProductResult" class="col-12 text-center">
                نتیجه ای یافت نشد
              </div>
              <div v-else-if="saveProducts.length <= 0" class="col-12  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  هنوز محصولی ذخیره نشده است
                </div>

              </div>
              <div v-for="(item,i) in saveProducts" v-else :key="i" class="col-12 py-1">
                <div class="row">
                  <div class="col-4 py-1">
                    <v-img :src="$replaceHttps(item.product.FileUrl)"
                           aspect-ratio="1"
                           :lazy-src="$replaceHttps(item.product.FileUrl)"
                           class="rounded-lg text-left d-flex align-items-end">
                      <div class="ml-2"><i class="fa-solid fa-star yellow--text ml-1"></i>{{ item.product.avgVote }}
                      </div>

                    </v-img>
                  </div>
                  <div class="col-8 py-1 pr-0 justify-space-between d-flex flex-column">
                    <div>{{ item.NameProduct }}</div>
                                        <v-checkbox
                                            v-model="item.ShowInProfile"
                                            hide-details
                                            @change="changeShowInProfile(item.RelationID,item.ShowInProfile)"
                                            class="mt-0">
                                          <template slot="label">
                                            <div class="font12px text-right">
                                              آیا مایلید در پروفایل کاربری خود این نظر انتشار یابد؟
                                            </div>

                                          </template>
                                        </v-checkbox>
                    <div>
                      <span>
                         <v-btn icon @click="removeBookMark(item.BookMarkID)">
                          <i class="fa-regular fa-trash-can fa-lg"></i>
                        </v-btn>
                      </span>
                      <span class="float-left  ml-2">
                        <span v-if="item.diffrenceDate === 0">امروز</span>
                        <span v-else>                            {{ item.diffrenceDate }} روز پیش
                        </span>
                        <v-btn :to="{name:'ProductDetail',query:{VendorProductID:item.RelationID}}" icon>
                                                  <i class="fa-solid fa-eye fa-lg"></i>

                        </v-btn>
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";

export default {
  name: "BuyerSaveProducts",
  metaInfo: {
    title: 'ایوان خانه- محصولات ذخیره شده',
  },
  components: {BackBar},
  data: () => ({
    saveProducts: [],
    isDataLoaded: false,
    showLoaderDialog: false,
    showResult: false,
    resultText: null,
    searchKeyWordProduct: '',
    hasFavoriteProductResult: true,
    allSave: [],

  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/BookMarkProduct/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let allProducts = this.$store.getters.getProductsList
            for (let i = 0; i < json.length; i++) {
              let now = new Date()
              json[i].diffrenceDate = parseInt(((now - new Date(json[i].ModifiedDate)) / (1000 * 60 * 60 * 24)))
              let find = allProducts.find(x => x.VendorProductID === json[i].RelationID)
              let voteArr = find.VoteViewModel
              if (voteArr !== null) {
                let num = voteArr.length
                let sumVote = 0
                for (let j = 0; j < voteArr.length; j++) {
                  sumVote += voteArr[j].Rate
                }
                let avg = sumVote / num;
                if (avg > 0) {
                  find.avgVote = sumVote / num
                } else {
                  find.avgVote = 0
                }
              } else {
                find.avgVote = 0
              }
              json[i].product = find
            }

            this.allSave = json
            this.saveProducts = json
            this.showLoaderDialog = false
            this.isDataLoaded = true
          })
          .catch(error => console.log('error', error));

    },
    removeBookMark(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("BookMarkID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/RemoveBookMark", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getData()
          })
          .catch(error => console.log('error', error));
    },
    searchProduct() {
      let result = this.saveProducts.filter(x => x.NameProduct.includes(this.searchKeyWordProduct));
      if (this.searchKeyWordProduct === '') {
        this.saveProducts = this.allSave
      } else {
        if (result.length === 0) {
          this.hasFavoriteProductResult = false
        } else {
          this.hasFavoriteProductResult = true
          this.saveProducts = result
        }
      }
    },
    changeShowInProfile(id,status) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("RelationID", id);
      urlencoded.append("TypeBookMark", "1");

        urlencoded.append("ShowInProfile", status);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetBookMark", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
             this.getData()
            }
            this.resultText = result
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    removeSearchHistory() {
      this.saveProducts = this.allSave
      this.hasFavoriteProductResult = true
    }
  }
}
</script>

<style scoped>

</style>
